<template>
    <div class="row" v-if="RenderForm">
        <template v-if="KlinikInformation && PasienInformation && DokterInformation">
            <div class="col-12 surat-penunjang-form" ref="PrintLetterRef" :class="PrintLetterClass">
                <ValidationObserver ref="SuratFormObserver">
                    <SuratPenunjangFormsBaseHeader :KlinikIMG="KlinikInformation.KlinikIMG"
                        :KlinikName="KlinikInformation.KlinikName" :KlinikAddress="KlinikInformation.KlinikAddress"
                        :LetterTitle="TypeOfLetter"
                        :increaseFont="true"
                         />
                    <template v-if="TypeOfLetter">

                        <component ref="SuratFormBody" :class="LetterClassName" :is="DynamicSuratPenunjangFormComponent"
                            @ComponentMounted="HandleComponentMounted" />
                    </template>
                </ValidationObserver>
                <SuratPenunjangFormsBaseFooter @SaveLetter="HandleSavingLetter" @PrintLetter="PrintPDF" class="no-print" :increaseFont="true" :LetterTitle="TypeOfLetter" />
            </div>
        </template>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { jsPDF } from 'jspdf'
import { NomorSuratMonthYear } from '../Helpers/DateSurat'
import { GenerateGUID } from '../Helpers/GUID'
import { toJpeg } from 'html-to-image';

export default {
    name: 'SuratPenunjangForm',
    components: {
        SuratPenunjangFormsBaseHeader: () => import('./Base/SuratPenunjangFormsBaseHeader.vue'),
        SuratPenunjangFormsBaseFooter: () => import('./Base/SuratPenunjangFormsBaseFooter.vue'),
    },
    props: {
        IsPembayaran: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        RekamMedisPenunjang: {
            handler: function (val) {
                if (val && val.RekamMedisPenunjangDiagnosisPrimary) {
                    this.$nextTick(() => {
                        this.updatePostData({
                            key: 'kode_penyakit_primary',
                            value: val.RekamMedisPenunjangDiagnosisPrimary
                        });
                    })
                }
                if (val && val.RekamMedisPenunjangDiagnosis.length > 0) {
                    this.$nextTick(() => {
                        this.updatePostData({
                            key: 'kode_penyakit',
                            value: val.RekamMedisPenunjangDiagnosis
                        });
                    })
                }

                if (val && val.Anamnesa) {
                    this.$nextTick(() => {
                        const TargetKey = ['tinggi_badan', 'berat_badan', 'suhu', 'tensi_sistole', 'tensi_diastole', 'nadi', 'respirasi', 'lingkar_perut', 'imt']

                        TargetKey.forEach((key) => {
                            this.updatePostData({
                                key,
                                value: val.Anamnesa[key]
                            });
                        })
                    })
                }

                if (val && val.Anamnesa && val.Anamnesa.notes) {
                    this.$nextTick(() => {
                        this.updatePostData({
                            key: 'anamnesa_text',
                            value: val.Anamnesa.notes
                        });
                    })
                }
            },
            deep: true,
            immediate: true
        },
    },
    mounted() {
        if (this.CurrentlyComposeLetter) {
            this.$nextTick(async () => {
                this.SetAtPembayaranPageMutation(this.IsPembayaran)

                await this.ProxyGetLayanan()

                this.$nextTick(async () => {
                    if (!this.LetterID) {
                        await this.GenerateNomorSurat()
                    }

                    await this.GetRekamMedis()
                    await this.GetKlinikInformation()
                    await this.GetPasienInformation()

                    if (this.IsPembayaran) {
                        await this.GetDokterIDPembayaran()
                    } else {
                        await this.GetDokterInformation()
                    }
                })

                this.$nextTick(() => {
                    this.SetRenderFormMutation(true)
                })
            })
        }
    },
    beforeDestroy() {
        this.ResetSuratPenunjangStore()
    },
    computed: {
        ...mapState(['rekamMedis']),
        ...mapGetters('SuratPenunjangStore', ['BASE_API_URL', 'API_URL']),
        ...mapState('SuratPenunjangStore', ['KlinikInformation', 'PasienInformation', 'DokterInformation', 'TypeOfLetter', 'CurrentlyPrintingLetter', 'CurrentlySavingLetter', 'PasienIDFromPembayaran', 'LetterID', 'RekamMedisIDFromPembayaran', 'CurrentlyComposeLetter', 'RekamMedisPenunjang', 'TataLaksanaPenunjang', 'RenderForm', 'BaseLetterNumber', 'LetterNumber', 'TransKlinikIDFromPembayaran']),
        ...mapState(['user', 'klinikUser', 'klinikId', 'rekamMedis']),
        DynamicSuratPenunjangFormComponent() {
            return () => import(`./Body/${this.TypeOfLetter.split(' ').join('')}Body.vue`)
        },
        UserProfile() {
            return this.klinikUser.find(data => data.id == this.klinikId);
        },
        ExaminerId() {
            return this.rekamMedis.transaksi.examination_by
        },
        PrintLetterClass() {
            return this.CurrentlyPrintingLetter || this.CurrentlySavingLetter ? 'print-letter' : '';
        },
        LetterClassName() {
            return this.TypeOfLetter.toLowerCase().split(' ').join('-')
        }
    },
    methods: {
        NomorSuratMonthYear,
        GenerateGUID,
        ...mapMutations(['SET_LOADING']),
        ...mapActions(['updatePostData']),
        ...mapActions('SuratPenunjangStore', ['ResetSuratPenunjangStore']),
        ...mapMutations('SuratPenunjangStore', ['SetDokterInformationMutation', 'SetKlinikInformationMutation', 'SetPasienInformationMutation', 'SetCurrentlyPrintingLetterMutation', 'SetCurrentlySavingLetterMutation', 'SetEditModeLetterMutation', 'SetLetterNumber', 'SetRekamMedisPenunjangMutation', 'SetTataLaksanaPenunjangMutation', 'SetRenderFormMutation', 'SetAtPembayaranPageMutation', 'SetBaseLetterNumberMutation', 'SetLetterID']),
        async GeneratePDFBase64() {
            const PrintElement = this.$refs.PrintLetterRef;

            const options = {
                quality: 0.19, pixelRatio: 1.3, backgroundColor: '#fff', skipAutoScale: true, type: 'image/jpeg', allowTaint: false, useCORS: true, cacheBust: true
            }

            const imgData = await toJpeg(PrintElement, options)

            // Create a new jsPDF instance
            const pdf = new jsPDF('p', 'mm', 'a4');

            // Get page dimensions
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            // Create a new Image object
            const img = new Image();
            img.src = imgData;

            // Wait until image data is loaded
            await new Promise(resolve => {
                img.onload = resolve;
            });

            // Get image dimensions
            const imageWidth = img.width;
            const imageHeight = img.height;

            // Calculate aspect ratio
            const widthRatio = pageWidth / imageWidth;
            const heightRatio = pageHeight / imageHeight;
            const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

            // Calculate image dimensions after scaling
            const scaledWidth = imageWidth * ratio;
            const scaledHeight = imageHeight * ratio;

            // Calculate position for center alignment
            const x = (pageWidth - scaledWidth) / 2;
            let y = (pageHeight - scaledHeight) / 2;

            // If image is not long enough, position it at the top
            if (scaledHeight < pageHeight) {
                y = 0;
            }

            // Add image to PDF
            pdf.addImage(imgData, 'JPEG', x, y, scaledWidth, scaledHeight, undefined, 'SLOW');

            // Output the PDF as datauri (base64 string)
            const pdfBase64String = pdf.output('datauristring', { filename: GenerateGUID() });

            return pdfBase64String;
        },
        async PrintPDF() {
            this.SET_LOADING(true)
            this.$refs.SuratFormObserver.validate().then(async (success) => {
                if (success) {
                    this.SetCurrentlyPrintingLetterMutation(true);
                    this.SetCurrentlySavingLetterMutation(true);

                    this.$nextTick(async () => {
                        const result = await this.$refs.SuratFormBody[this.LetterID ? 'UpdateData' : 'SaveData']();

                        if (!this.LetterID) {
                            await this.IncreaseNomorSuratCounter();
                        }

                        this.SetLetterID(result.id);
                        this.$nextTick(async () => {                            
                            const TmpPDFBlob = await fetch(result.pdf_base64).then(res => res.blob());

                            const PDFBlob = URL.createObjectURL(TmpPDFBlob);
                            if (this.isMobile() || this.isMobileTab()) {
                                const link = document.createElement('a');
                                link.href = PDFBlob;
                                link.target = '_blank';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                setTimeout(() => {
                                    this.$nextTick(async () => {
                                        URL.revokeObjectURL(PDFBlob);
                                        this.SET_LOADING(false);
                                        this.SuccessSWAL();
                                    })
                                }, 1000);
                                return;
                            }

                            const TargetIframePDF = document.querySelector('#LetterIframe');

                            if (TargetIframePDF) {
                                document.body.removeChild(TargetIframePDF);
                            }

                            // Create a new iframe
                            let iframe = document.createElement('iframe');

                            // Set iframe attributes
                            iframe.setAttribute('style', 'position:absolute;right:0; top:0; bottom:0; height:100%; width:500px; padding:20px; z-index:-9999;');
                            iframe.setAttribute('id', 'LetterIframe');
                            iframe.src = PDFBlob;

                            // Append iframe to body
                            document.body.appendChild(iframe);

                            // Wait for iframe to load
                            iframe.onload = () => {
                                setTimeout(() => {
                                    // After iframe has completely loaded, print
                                    iframe.contentWindow.print();

                                    URL.revokeObjectURL(PDFBlob);

                                    this.$nextTick(async () => {
                                        this.SetCurrentlyPrintingLetterMutation(false);
                                        this.SetCurrentlySavingLetterMutation(false);
                                        this.SET_LOADING(false);
                                        this.SuccessSWAL();
                                    })
                                }, 1000);
                            }
                        });
                    });
                } else {
                    this.SET_LOADING(false);
                }
            }).catch(err => {
                // console.log(err)
            })
        },
        async HandleSavingLetter() {
            this.SET_LOADING(true)
            this.$refs.SuratFormObserver.validate().then(async (success) => {
                if (success) {
                    this.SetCurrentlyPrintingLetterMutation(true);
                    this.SetCurrentlySavingLetterMutation(true);

                    this.$nextTick(async () => {
                       await this.$refs.SuratFormBody[this.LetterID ? 'UpdateData' : 'SaveData']();

                        if (!this.LetterID) {
                            await this.IncreaseNomorSuratCounter();
                        }

                        this.$nextTick(() => {
                            this.SetCurrentlySavingLetterMutation(false);
                            this.SetCurrentlyPrintingLetterMutation(false);
                            this.SET_LOADING(false);
                            this.SuccessSWAL();
                        });
                    });
                } else {
                    this.SET_LOADING(false);
                }
            }).catch(err => {
                // console.log(err)
            });
        },
        SuccessSWAL() {
            this.$swal({
                title: 'Tersimpan',
                html: `Surat berhasil di simpan.`,
                type: 'success',
                showCancelButton: false,
            }).then((result) => {
                if (result.value) {
                    this.$nextTick(() => {
                        this.ResetSuratPenunjangStore()
                    })
                }
            })
        },
        HandleComponentMounted() {
            if (this.LetterID) {
                this.$nextTick(this.HandleEditModeLetter)
            }
        },
        HandleEditModeLetter() {
            this.$nextTick(() => {
                this.$refs.SuratFormBody.GetData()
            })
        },
        async GetDokterIDPembayaran() {
            const res = await this.$axios.get(
                `${this.API_URL}/daftar-surat/dokter-id-pembayaran/${this.TransKlinikIDFromPembayaran}`
            );

            const data = res.data;

            if (data && data.user_id) {
                await this.GetDokterInformation(data.user_id)
            }
        },
        async GetDokterInformation(DokterID) {
            const tmp = DokterID ? DokterID : this.user.id
            const res = await this.$axios.get(
                `klinik/dokter/${tmp}?klinik_id=${this.klinikId}&profile=true`
            );

            const { data } = res.data;

            this.SetDokterInformationMutation(data)
        },
        async GetKlinikInformation() {
            const { id, parent_id } = this.UserProfile
            const { data } = await this.$axios.get(`${this.BASE_API_URL}/klinik/${id}?klinik_id=${parent_id}&profile=true`);

            this.SetKlinikInformationMutation(data.data)
        },
        async GetPasienInformation() {
            const { id } = this.UserProfile
            const PasienID = this.$router.currentRoute.params.pasien_id || this.PasienIDFromPembayaran;

            const { data } = await this.$axios.get(`${this.BASE_API_URL}/pasien/${PasienID}?klinik_id=${id}&id=${PasienID}&with_parent=1`)

            const { tinggi_badan, berat_badan, suhu, tensi_sistole, tensi_diastole, nadi, respirasi, lingkar_perut, imt, golongan_darah } = this.rekamMedis.postData

            const PasienData = { ...data.data, tinggi_badan, berat_badan, suhu, tensi_sistole, tensi_diastole, nadi, respirasi, lingkar_perut, imt, golongan_darah }

            const AnamnesaRekamMedis = this.rekamMedis.postData.anamnesa_text

            const anamnesa = data.data.anamnesa && data.data.anamnesa !== '' ? data.data.anamnesa : AnamnesaRekamMedis

            this.SetPasienInformationMutation({ ...PasienData, anamnesa })
        },
        async ProxyGetLayanan() {
            if (!this.IsPembayaran && this.rekamMedis.postData && this.rekamMedis.postData.tatalaksana) {
                this.SetTataLaksanaPenunjangMutation(this.rekamMedis.postData.tatalaksana)

                this.$nextTick(async () => this.MapTataLaksana)
            } else {
                await this.MapTataLaksana()
            }
        },
        async MapTataLaksana() {
            if (this.TataLaksanaPenunjang && this.TataLaksanaPenunjang.length > 0) {
                const LayananMap = { 2: 'Obat', 4: 'Tindakan' }
                const IDTataLaksanaPenunjang = this.TataLaksanaPenunjang.map((item) => {
                    return item.layanan_id
                })

                const data = await this.GetLayanan(IDTataLaksanaPenunjang)

                const TmpTataLaksana = this.TataLaksanaPenunjang.map((item) => {
                    const KategoriLayanan = data.find((Layanan) => Layanan.id === item.layanan_id)

                    return {
                        ...item,
                        kategori_layanan: KategoriLayanan ? LayananMap[KategoriLayanan.kategori_id] : null
                    }
                })

                const FinalTataLaksana = TmpTataLaksana.filter(Layanan => Layanan.kategori_layanan !== null)

                this.SetTataLaksanaPenunjangMutation(FinalTataLaksana)
            }
        },
        async GetLayanan(IDTataLaksanaPenunjang) {
            if (IDTataLaksanaPenunjang) {
                const { data } = await this.$axios.get(`${this.API_URL}/layanan-shadow/${IDTataLaksanaPenunjang}`)

                return data
            } else {
                return null
            }
        },
        async GetRekamMedis() {
            let RekamMedisID = localStorage.getItem('rekam_medis_id')

            if (this.IsPembayaran) {
                RekamMedisID = this.RekamMedisIDFromPembayaran
            }

            if (RekamMedisID) {
                const { data } = await this.$axios.get(`${this.BASE_API_URL}/rekam_medis/${RekamMedisID}?id=${RekamMedisID}`)

                this.SetRekamMedisPenunjangMutation(data.data)
            }
        },
        async GenerateNomorSurat() {
            const { data } = await this.$axios.get(`${this.BASE_API_URL}/surat-penunjang/daftar-surat/nomor-surat/${this.klinikId}`)

            const SuratKeluarNumber = await this.GenerateNomorSuratCounter()

            const LetterNumber = `${SuratKeluarNumber}/IZD-${data}/${this.NomorSuratMonthYear()}`
            this.SetLetterNumber(LetterNumber)
            this.SetBaseLetterNumberMutation(LetterNumber)
        },
        async GenerateNomorSuratCounter() {
            const LetterTitle = this.TypeOfLetter.toLowerCase().split(' ').join('-')

            const { data } = await this.$axios.get(`${this.BASE_API_URL}/surat-penunjang/daftar-surat/nomor-surat-counter/${this.klinikId}/${LetterTitle}`)

            const TMPNumber = data || 1

            const SuratKeluarNumber = (TMPNumber).toString().padStart(Math.max((TMPNumber).toString().length, 4), '0');

            return SuratKeluarNumber
        },
        async IncreaseNomorSuratCounter() {
            const LetterTitle = this.TypeOfLetter.toLowerCase().split(' ').join('-')

            const { data } = await this.$axios.post(`${this.BASE_API_URL}/surat-penunjang/daftar-surat/nomor-surat-counter/${this.klinikId}/${LetterTitle}`)

            return data
        }
    }
}
</script>

<style lang="scss">
.surat-penunjang-form {
    .mx-datepicker {
        width: 100%;
    }

    .pasien-anamnesa {
        * {
            margin: 0;
            padding: 0;
        }
    }

    .form-control {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .multiselect__tags {
        padding-left: 1rem;

        .multiselect__single {
            padding-left: 0;
        }
    }

    &.print-letter {
        * {
            text-shadow: none;
            box-shadow: none;
            animation: none;
            -webkit-animation: none;
            transition: none;
            -webkit-transition: none;
            -webkit-font-smoothing: none;
            -moz-osx-font-smoothing: grayscale;
        }

        .no-print {
            display: none;
        }

        .custom-checkbox .custom-control-input {
            &~.custom-control-label::before {
                border: none;
            }

            &:checked {
                &~.custom-control-label::after {
                    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAAmJLR0QA/4ePzL8AAABQSURBVAjXY2BAAv8FGFC4Vv/f/48EMTih3E////9fwfDf9f+z/yb/Lf9/BHLX/mdl+L8RyHgD5q4HckEa/u/+DwLb/rPDDAMJIbhQITYYGwAKozbUNSGDUQAAAABJRU5ErkJggg==");
                }
            }
        }
    }
}
</style>